import { ITableColumn } from '@components/common/UTable/UTable';
import { useMemo } from 'react';

import {
  FarmingCell,
  FarmingCellProps,
} from '@/pages/Farming/components/FarmingCell/FarmingCell';
import { FarmingCommonTitle } from '@/pages/Farming/components/FarmingCommonTitle/FarmingCommonTitle';
import { canFarmAction } from '@/pages/Farming/components/FarmingTable/FarmingTable';
import { FirstCell } from '@/pages/Farming/components/FirstCell/FirstCell';
import { UUID } from '@/shared/api/types';

import { FarmFilterUpdate, TransformedMatrixItem } from '../../types';

export const useColumns = (
  countColumn: number,
  handleDeleteRow: (filters: FarmFilterUpdate) => void,
  activeCell: UUID,
  onAddIndiv: (columnIndex: number, rowIndex: number) => void,
  onClearIndiv: (id: UUID, columnIndex: number, rowIndex: number) => void,
  canAction: canFarmAction,
) => {
  return useMemo(() => {
    const baseColumn = {
      title: <FirstCell />,
      dataIndex: 'rowIndex',
      width: 100,
      render: (value: number) => (
        <FarmingCommonTitle
          title={value + 1}
          onDelete={() => handleDeleteRow({ removingRow: value })}
          canAction={canAction}
        />
      ),
      onCell: () => ({
        style: {
          backgroundColor: '#D9D9D9',
        },
      }),
    };

    const dynamicColumns = Array.from({ length: countColumn }, (_, i) => ({
      title: (
        <FarmingCommonTitle
          title={i + 1}
          onDelete={() => handleDeleteRow({ removingColumn: i })}
          canAction={canAction}
        />
      ),
      dataIndex: `columnIndex${i}`,
      render: (
        value: FarmingCellProps,
        record: TransformedMatrixItem,
        rowIndex: number,
      ) => (
        <FarmingCell
          {...value}
          columnIndex={i}
          rowIndex={rowIndex}
          onAddIndiv={onAddIndiv}
          onClearIndiv={onClearIndiv}
          canAction={canAction}
        />
      ),
      onCell: (record: TransformedMatrixItem) => ({
        style: {
          backgroundColor:
            record[`columnIndex${i}`]?.id === activeCell ? '#DDF5FA' : undefined,
        },
      }),
    }));

    return [baseColumn, ...dynamicColumns] as ITableColumn[];
  }, [countColumn, handleDeleteRow, activeCell, onAddIndiv, onClearIndiv, canAction]);
};
